import { _ as _extends } from './_rollupPluginBabelHelpers-8c92bac3.js';
import React__default from 'react';
import cx from 'classnames';
import { T as ThemeContext } from './ThemeContext-e1f446be.js';

var styles = {"theme":"Theme_theme__3OTot"};

const ThemeDefault = props => {
  const {
    className,
    theme,
    ...p
  } = props; // eslint-disable-line no-unused-vars

  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: cx(styles.theme, className)
  }, p), props.children);
};

var styles$1 = {"theme":"ThemeDark_theme__36Dp0","mw-i":"ThemeDark_mw-i__28JzY"};

const ThemeDark = props => {
  const {
    className,
    theme,
    ...p
  } = props; // eslint-disable-line no-unused-vars

  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: cx('mw-parent-theme-dark', styles$1.theme, className)
  }, p), props.children);
};

class Theme extends React__default.Component {
  constructor(props) {
    super(props);
    this.renderWrappedChildren = this.renderWrappedChildren.bind(this);
    this.themes = ['default', 'dark'];
    if (props.theme === 'dark') {
      this.themes.reverse();
    }
    this.state = {
      theme: this.themes[0]
    };
  }
  changeTheme() {
    this.setState({
      theme: this.themes.reverse()[0]
    });
  }
  renderWrappedChildren(children) {
    return React__default.Children.map(children, child => {
      // This is support for non-node elements (eg. pure text), they have no props
      if (!child || !child.props) {
        return child;
      }
      if (child.props.children) {
        let props = {
          children: this.renderWrappedChildren(child.props.children)
        };
        if (typeof child.type !== 'string') {
          props.changeTheme = this.changeTheme.bind(this);
        }
        return /*#__PURE__*/React__default.cloneElement(child, props);
      }
      if (typeof child.type === 'string') {
        return child;
      }
      return /*#__PURE__*/React__default.cloneElement(child, {
        changeTheme: this.changeTheme.bind(this)
      });
    });
  }
  render() {
    const {
      children,
      doNotAlterChildren,
      ...p
    } = this.props;
    const Element = this.state.theme === 'dark' ? ThemeDark : ThemeDefault;
    /**
     * NOTE: Seller webapp does not like it's children altered, atm changing theme is not a priority,
     * Post lauch this should be fixed. 02/04/2019 / Rob
     */
    const content = doNotAlterChildren ? children : this.renderWrappedChildren(children);
    return /*#__PURE__*/React__default.createElement(ThemeContext.Provider, {
      value: {
        theme: this.state.theme
      }
    }, /*#__PURE__*/React__default.createElement(Element, p, content));
  }
}

export default Theme;
